module.exports = __webpack_public_path__ + "img/difficulty-red.5b09b9b9.svg";